<script setup lang="ts">
import { SharedData } from '@/@types'
import favicon from '@/assets/favicon.ico'
import TopBar from '@/components/Header/TopBar.vue'
import WhatsAppButton from '@/components/shared/WhatsAppButton.vue'
import { Toaster } from '@/components/ui/sonner'
import { Head, usePage } from '@inertiajs/vue3'
import { useUrlSearchParams } from '@vueuse/core'
import { computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { toast } from 'vue-sonner'

const page = usePage<SharedData>()

const flash = computed(() => {
    return page.props.flash
})

type I18nFlashMessage = {
    i18n_key: string
    i18n_params?: Record<string, string>
}

const { t } = useI18n()

const { download_pdf: downloadPdf } = useUrlSearchParams()

watch(flash, () => {
    const notice = flash.value.notice as string | I18nFlashMessage
    const alert = flash.value.alert as string | I18nFlashMessage

    if (notice) {
        if (typeof notice === 'string') {
            toast.success(t(notice))
        } else {
            toast.success(t(notice.i18n_key, notice.i18n_params || {}))
        }
    }

    if (alert) {
        if (typeof alert === 'string') {
            toast.error(t(alert))
        } else {
            toast.error(t(alert.i18n_key, alert.i18n_params || {}))
        }
    }
})

onMounted(() => {
    window.addEventListener('popstate', () => {
        toast.dismiss()
        sessionStorage.setItem('isBackNavigation', 'true')
    })
})
</script>
<template>
    <Head>
        <link rel="icon" :href="favicon" />
    </Head>
    <TopBar />
    <slot />
    <Toaster richColors position="top-right" closeButton />
    <WhatsAppButton v-if="downloadPdf !== 'true'" />
</template>
